import { Skeleton } from "@/shared/components/ui/skeleton"

interface VolunteersResultsCountProps {
    total: number
    activeTodayCount: number
    isLoading: boolean
    /** Narrow one-line copy for mobile under the filter/search toolbar */
    compact?: boolean
}

function VolunteersResultsCount({ total, activeTodayCount, isLoading, compact }: VolunteersResultsCountProps) {
    if (isLoading) {
        return (
            <Skeleton
                className={compact ? "h-4 w-36 max-w-full" : "h-6 w-48 max-w-full"}
                aria-hidden
            />
        )
    }

    if (compact) {
        return (
            <p
                className="text-xs text-muted-foreground tabular-nums leading-tight"
                aria-label={`Showing ${total.toLocaleString()} volunteers, ${activeTodayCount.toLocaleString()} last active today`}
            >
                Showing {total.toLocaleString()} · Today {activeTodayCount.toLocaleString()}
            </p>
        )
    }

    return (
        <div className="text-sm text-muted-foreground font-bold flex flex-wrap items-center gap-x-2 gap-y-1">
            <span>
                Showing {total.toLocaleString()} volunteer{total === 1 ? "" : "s"}
            </span>
            <span className="hidden md:inline font-medium text-muted-foreground/90" aria-label="Volunteers last active today">
                · Today {activeTodayCount.toLocaleString()} volunteer{activeTodayCount === 1 ? "" : "s"} (last active)
            </span>
        </div>
    )
}

export default VolunteersResultsCount
